<template>
    <div class="mt-2">
      <!-- start: page -->
      <div class="tabs">
        
        <div class="tab-content">
          <!-- novi superbonus -->
          <div id="super-bonus" class="tab-pane active">
            <form
              class="ecommerce-form action-buttons-fixed"
              @submit.prevent="submitsuperBonus"
            >
              <div class="row">
                <div class="col">
                  <!-- superbonus -->
                    <section class="card card-modern card-big-info mt-2">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-lg-2-5 col-xl-1-5">
                            <i class="card-big-info-icon bx bx-slider"></i>
                            <h2 class="card-big-info-title">
                              Super bonus program
                            </h2>
                            <p class="card-big-info-desc">
                              Aktiviraj super bonus program
                            </p>
                          </div>
                          <div class="col-lg-3-5 col-xl-4-5">
  
                            <div
                              class="form-group row align-items-center pb-3 pt-3"
                              :class="{ 'has-danger': $v.superBonusForm.dateFrom.$anyError }">
                              <label
                                class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                                >Vrijedi od</label
                              >
                              <div class="col-lg-7 col-xl-6">
                                <datepicker
                                  input-class="form-control form-control-modern bg-body"
                                  :monday-first="true"
                                  :full-month-name="true"
                                  :language="bs"
                                  :format="customFormatter"
                                  v-model="superBonusForm.dateFrom"
                                ></datepicker>
  
                                <form-error
                                  :model="$v.superBonusForm.dateFrom"
                                  label="Vrijedi od"
                                  :dirty="$v.superBonusForm.$dirty"
                                />
                              </div>
                            </div>
  
                            <div
                              class="form-group row align-items-center pb-3"
                              :class="{ 'has-danger': $v.superBonusForm.dateTo.$anyError }">
                              <label
                                class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                                >Vrijedi do</label
                              >
                              <div class="col-lg-7 col-xl-6">
                                <datepicker
                                  input-class="form-control form-control-modern bg-body"
                                  :monday-first="true"
                                  :full-month-name="true"
                                  :language="bs"
                                  :format="customFormatter"
                                  v-model="superBonusForm.dateTo"
                                ></datepicker>
                                <form-error
                                  :model="$v.superBonusForm.dateTo"
                                  label="Vrijedi do"
                                  :dirty="$v.superBonusForm.$dirty"
                                />
                              </div>
                            </div>
  
                            <!-- <div class="d-flex justify-content-end">
                              <button
                                type="submit"
                                class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
                                data-loading-text="Loading..."
                              >
                                <i class="bx bx-save text-4 me-2"></i> Aktiviraj super bonus program
                              </button>
                            </div> -->
                          </div>
                        </div>
                      </div>
                    </section>
                  <!-- kraj superbonus -->
                </div>
              </div>
              <div class="row mt-2">
                <div class="col">
                  <div class="card card-modern card-modern-table-over-header">
                    <div class="card-header">
                      <div class="row align-items-center mb-5">
                        <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                          <a
                            @click="openAddRangeModal"
                            class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim me-1"
                          >
                            + Dodaj stavku
                          </a>
                          <button
                            class="btn btn-warning btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim"
                            type="button"
                            @click.prevent.stop="showConfirmationModal"
                          >
                            - Ukloni stavku
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="card-body" style="margin-top: -20px">
                      <table
                        v-if="
                          superBonusForm.ranges &&
                          superBonusForm.ranges.length
                        "
                        class="table table-offer table-ecommerce-simple table-borderless table-striped mb-0"
                        style="min-width: 640px"
                      >
                        <thead>
                          <tr>
                            <th width="30">
                              <input
                                type="checkbox"
                                class="select-all checkbox-style-1 p-relative top-2"
                                v-model="selectAll"
                              />
                            </th>
                            <th>RBR</th>
                            <th>Min vrijednost</th>
                            <th>Max vrijednost</th>
                            <th>Rabat</th>
                            <!-- <th>Akcije</th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in superBonusForm.ranges"
                            :key="item.generatedId"
                          >
                            <td width="30">
                              <input
                                type="checkbox"
                                class="checkbox-style-1 p-relative top-2"
                                :value="item.generatedId"
                                v-model="selected"
                              />
                            </td>
                            <td>{{ index + 1 }}</td>
                            <td>{{ item.minAmount }}</td>
                            <td>
                              <strong>{{ item.maxAmount }}</strong>
                            </td>
                            <td>
                              <strong>{{ item.discount }}</strong>
                            </td>
                            <!-- <td @click.prevent.stop="showEditModal(item)">
                              <i class="fa fa-edit"></i>
                            </td> -->
                          </tr>
                        </tbody>
                      </table>
                      <div v-else>
                        <div class="alert alert-info" role="alert">
                          {{ translations.noRecords }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="action-buttons d-flex justify-content-between">
                <div>
                </div>
                <div class="d-flex gap-3">
                  <router-link
                    exact
                    :to="{ name: 'EditCompany', params: {companyId: this.$route.params.companyId} }"
                    class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
                  >
                    {{ translations.cancel }}
                  </router-link>
                  <button
                    type="submit"
                    class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
                    data-loading-text="Loading..."
                  >
                    <i class="bx bx-save text-4 me-2"></i> Aktiviraj super bonus program
                  </button>
                </div>
              </div>
            </form>
          </div>
          <!-- kraj novi superbonus -->
  
          <form @submit.prevent="addRange">
            <modal id="add-range" cssClass="modal-md-2">
              <header slot="header">
                <h2 class="card-title">Dodavanje stavke</h2>
              </header>
              <section slot="body">
                <div class="card-body">
  
                  <div class="form-group row">
                    <label
                      class="col-lg-4 control-label text-lg-end pt-2"
                      for="add-min-amount"
                      >Min vrijednost</label
                    >
                    <div class="col-lg-8">
                      <input
                        placeholder="Min vrijednost"
                        type="text"
                        class="form-control form-control-modern"
                        id="add-min-amount"
                        v-model.number="itemNewForm.minAmount"
                        readonly
                      />
                      <form-error
                        :model="$v.itemNewForm.minAmount"
                        :dirty="$v.itemNewForm.$dirty"
                        label='Min vrijednost'
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label
                      class="col-lg-4 control-label text-lg-end pt-2"
                      for="add-max-amount"
                      >Max vrijednost</label
                    >
                    <div class="col-lg-8">
                      <input
                        placeholder="Max vrijednost"
                        type="text"
                        class="form-control form-control-modern"
                        id="add-max-amount"
                        v-model.number="itemNewForm.maxAmount"
                      />
                      <form-error
                        :model="$v.itemNewForm.maxAmount"
                        :dirty="$v.itemNewForm.$dirty"
                        label='Max vrijednost'
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label
                      class="col-lg-4 control-label text-lg-end pt-2"
                      for="add-discount"
                      >Rabat</label
                    >
                    <div class="col-lg-8">
                      <input
                        placeholder="Rabat"
                        type="text"
                        class="form-control form-control-modern"
                        id="add-discount"
                        v-model.number="itemNewForm.discount"
                      />
                      <form-error
                        :model="$v.itemNewForm.discount"
                        :dirty="$v.itemNewForm.$dirty"
                        label='Rabat'
                      />
                    </div>
                  </div>
                </div>
              </section>
              <footer slot="footer">
                <div class="row">
                  <div class="col-md-12 text-end">
                    <!-- <button
                      class="btn btn-default modal-dismiss mx-2"
                      aria-label="Close"
                      @click="closeNewModal"
                    >
                      Odustani
                    </button> -->
                    <button class="btn btn-primary modal-confirm" type="submit">
                      Dodaj stavku
                    </button>
                  </div>
                </div>
              </footer>
            </modal>
          </form>
          <modal id="confirm-delete">
        <h5 slot="header">
          <strong>Ukloni odabrane stavke</strong>
        </h5>
        <div slot="body">
          Jeste li sigurni da želite ukloniti odabrane stavke?
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent.stop="removeRanges"
                data-bs-dismiss="modal"
              >
                {{ translations.yes }}
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>
        </div>
      </div>
      <!-- end: page -->
    </div>
  </template>
  
  <script>
  
  import Datepicker from 'vuejs-datepicker';
  import bs from 'vuejs-datepicker/dist/locale/translations/bs';
  import { format } from 'date-fns';
  
  import { translations } from '@/mixins';
  import superBonusValidations from './validation-schema/super-bonus';
  import itemValidation from './validation-schema/item-add-or-edit';
  import api from '@/services/api';
  import config from '@/config';
  import FormError from '../shared/form-errors/FormError.vue';
  import Modal from '../shared/modal/Modal.vue';
  
  const currentDate = new Date();
  const toDate = new Date();
  toDate.setDate(currentDate.getDate() + 365);
  export default {
    name: 'AddSuperBonus',
    mixins: [translations],
    components: {
      FormError,
      Datepicker,
      Modal,
    },
    validations: {
      superBonusForm: superBonusValidations,
      itemNewForm: itemValidation,
    },
    data() {
      return {
        posterUrl: null,
        baseUrl: config.baseUrl,
        selected: [],
        superBonusForm: {
            dateFrom: currentDate,
            dateTo: toDate,
            ranges: []
        },
        itemNewForm: {
          minAmount: null,
          maxAmount: null,
          discount: null,
          generatedId: null,
        },
        itemEditForm: {
          minAmount: null,
          maxAmount: null,
          discount: null,
          generatedId: null,
        },
      };
    },
    computed: {
      bs() {
        return bs;
      },
      selectAll: {
        get: function () {
          return (
            this.selected.length === this.superBonusForm.ranges.length
          );
        },
        set: function (value) {
          const selected = [];
  
          if (value) {
            this.superBonusForm.ranges.forEach(function ({
              generatedId,
            }) {
              selected.push(generatedId);
            });
          }
  
          this.selected = selected;
        },
      },
      isFormValidSuperBonus() {
        return !this.$v.superBonusForm.$invalid;
      },
      isItemNewFormValid() {
        return !this.$v.itemNewForm.$invalid;
      },
    },
    mounted() {
    },
    methods: {
      openAddRangeModal() {
        $('#add-range').modal('show');
        if (this.superBonusForm.ranges.length > 0) {
          const maxAmount = this.superBonusForm.ranges.reduce(
            (max, range) => (range.maxAmount > max ? range.maxAmount : max),
            this.superBonusForm.ranges[0].maxAmount
          );
          this.itemNewForm.minAmount = maxAmount + 0.01;
        } else {
          this.itemNewForm.minAmount = 0;
        }
      },
      addRange() {
        this.$v.itemNewForm.$touch();
  
        if (!this.isItemNewFormValid) {
          this.$toast.error(this.translations.forms.notValid);
          return;
        }
  
        var areCorrectValues = this.superBonusForm.ranges.some(
          (x) =>
            (this.itemNewForm.minAmount <= x.minAmount &&
              this.itemNewForm.maxAmount >= x.maxAmount) ||
            (this.itemNewForm.maxAmount >= x.minAmount &&
              this.itemNewForm.maxAmount <= x.maxAmount) ||
            (this.itemNewForm.minAmount >= x.minAmount &&
              this.itemNewForm.minAmount <= x.maxAmount)
        );
  
        if (this.itemNewForm.minAmount >= this.itemNewForm.maxAmount) {
          this.$toast.error('Neispravne vrijednosti!');
        } else if (areCorrectValues) {
          this.$toast.error('Vrijednost već postoji u stavkama!');
        } else {
          this.itemNewForm.generatedId = this.generateRandomId();
          this.superBonusForm.ranges.push({ ...this.itemNewForm });
          this.closeNewModal();
        }
      },
      showConfirmationModal() {
        if (this.selected.length) $('#confirm-delete').modal('show');
      },
      removeRanges() {
        if (this.selected.length === this.superBonusForm.ranges) {
          this.superBonusForm.ranges =
            this.superBonusForm.ranges.filter(
              (item) => !this.selected.includes(item.generatedId)
            );
        } else {
          let data = [...this.superBonusForm.ranges];
          data.sort((a, b) => b.maxAmount - a.maxAmount);
  
          let tempSelected = [...this.selected];
          let length =
            tempSelected.length > data.length ? data.length : tempSelected.length;
  
          for (let i = 0; i < length; i++) {
            if (tempSelected.includes(data[i].generatedId)) {
              this.superBonusForm.ranges =
                this.superBonusForm.ranges.filter(
                  (item) => item.generatedId != data[i].generatedId
                );
            } else {
              this.$toast.error(
                'Molimo da prvo obrišete stavke sa maksimalnom vrijednošću'
              );
              break;
            }
          }
          this.selected = [];
        }
      },
      closeNewModal() {
        $('#add-range').modal('hide');
        this.$v.itemNewForm.$reset();
        this.itemNewForm.maxAmount = null;
        this.itemNewForm.minAmount = null;
        this.itemNewForm.discount = null;
        this.itemNewForm.generatedId = null;
      },
      submitsuperBonus() {
        this.$v.superBonusForm.$touch();
  
        if (!this.isFormValidSuperBonus) {
          this.$toast.error(this.translations.forms.notValid);
          return;
        }
  
        const { superBonusForm } = this;
  
        api.createCompanySuperBonus(this.$route.params.id, superBonusForm)
        .then((response) => {
            this.$toast.info(response.data.info);
            this.$router.push({ name: 'EditCompany', params: { id: this.$route.params.id } });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
      },
      generateRandomId() {
        return -Math.ceil(Math.random() * 1000000);
      },
      customFormatter(date) {
        return format(date, 'dd.MM.yyyy.');
      },
    },
  };
  </script>
  
  <style lang="scss">
  .tab-content {
    background: transparent;
    padding: 0;
    box-shadow: none;
    border: none;
  }
  </style>
  